import dayjs from 'dayjs';

import { Month, TableCell } from './booking-types';

const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const monthsOrder = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

export const splitYearIntoMonths = (year: number, yearCells: TableCell[]): Month[] => {
  const yearCellsClone = [...yearCells];

  return monthsOrder.map((monthIndex: number): Month => {
    const firstDayOfMonth = dayjs(`${year}-${monthIndex}-01`, 'YYYY-M-DD');
    const numberOfDaysInMonth = firstDayOfMonth.daysInMonth();
    const monthCells = [...yearCellsClone.splice(0, numberOfDaysInMonth)];
    return { name: monthNames[monthIndex - 1], days: monthCells.map((dayObject, index) => ({ ...dayObject, day: `${index + 1}` })) };
  });
};
